import React, { Component } from 'react'
import Play from '../SVG/Play';
export default class Listening extends Component {
     state={}
     render() {
        const {onPlay, listensremaining, step, file} = this.props;
        const {isPlaying} = this.state;
 
    

    return (<div><audio style={{ opacity: 0 }} id="listening-audio" src={file} onPause={()=>this.setState({isPlaying:false})}></audio>
      <button disabled={(listensremaining!==null && listensremaining<1) || isPlaying} className='btn p-0' onClick={()=>{ if (onPlay!==undefined) onPlay();this.setState({isPlaying:true});document.getElementById("listening-audio").play() }}>

        <Play></Play>
      </button>
      {step === 1 && listensremaining!==null && <div className='text-center'>
      <p className='fw-bold'>
        {listensremaining} Listens Remaining
      </p></div>}
      </div>
    )
  }
}
